import { Button, Box, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom"; 
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

const CustomTypography = styled(Typography) (({theme}) => ({
    background: 'linear-gradient(316.91deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 64.77%, #6B3A8F 94.98%, #5D2A79 115.46%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
    fontWeight: 'bold'
}))

export default function CourseInformation({course}) {
    const navigate = useNavigate();

    const viewCourseTopics = (idCourse, courseName) => {
        localStorage.setItem("course", JSON.stringify({courseName: courseName}))
        navigate(`/courses/${idCourse}`)
    }

    return (
        <Box sx={{
            display: Object.keys(course).length === 0 ? 'none' : 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '90%',
            height: '85%',
            marginTop: '5%',
            position:'relative',
            background: 'linear-gradient(144.47deg, #1D151D 42.84%, #4E2D33 179.39%)',
            borderRadius: '24px',
            padding: '5%',
            zIndex: 1,
            
            "&::before": {
                content: '""',
                position: "absolute",
                inset: 0, // Covers the entire box
                borderRadius: "24px", // Ensures rounded corners
                padding: "3px", // Thickness of the border
                background: "linear-gradient(316.91deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 38.67%, #6B3A8F 78.77%, #5D2A79 115.46%)", 
      
                // Masks the inner part, leaving only the border
                WebkitMask: "linear-gradient(white 0 0) content-box, linear-gradient(white 0 0)",
                WebkitMaskComposite: "destination-out",
                maskComposite: "exclude",
      
                zIndex: -1,
            }
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                
            }}>
                <CustomTypography variant="h6">
                    Course Description:
                </CustomTypography>
                <Typography variant="h7" sx={{color: '#E1E1E6'}} data-cy='course-description'>{course.description}</Typography>
                {/* TODO: Write Topics */}
                {/* <CustomTypography variant="h6">
                    Topics:
                </CustomTypography>
                <Typography sx={{color: '#E1E1E6', fontWeight:'bold'}}>Lorem Ipsum</Typography> */}
                <CustomTypography variant="h6" data-cy='course-outcome'>
                    Outcomes:
                </CustomTypography>
                <Typography variant="h7" sx={{color: '#E1E1E6'}}>{course.outcome}</Typography>
            </Box>

            <Button 
                data-cy='start-course-button'
                startIcon={<PlayArrowRoundedIcon />}
                variant="outlined"
                onClick={() => viewCourseTopics(course._id.toString(), course.name)}
                sx={{
                    color: '#C071FF',
                    width: '30%',
                    height: '10%',
                    background: '#7903D74D',
                    border: '1.06px solid #C071FF',
                    borderRadius: '17px',
                    "&:hover": {
                        backgroundColor: '#2f002e',
                        border: '1.06px solid #C071FF',
                        transform: "scale(1.05)"
                    }
                }}
            >
                Start Course
            </Button>
        </Box>
    )

}